import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-perquisa-rol-guardia',
  templateUrl: './perquisa-rol-guardia.component.html',
  styleUrls: ['./perquisa-rol-guardia.component.scss'],
})
export class PerquisaRolGuardiaComponent implements OnInit {
  form: FormGroup;

  @Input() data: { task: any };

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
    const { task } = this.data;
    const values = task.data ? task.data : null;
    this.form = this.fb.group({
      descripcion: [values ? values.descripcion : '', [Validators.required]],
      n_oficio: [values ? values.n_oficio : '', [Validators.required]],
    });
  }
  verificateInput(value: string) {
    return (
      this.form.get(value)?.invalid &&
      (this.form.get(value)?.dirty || this.form.get(value)?.touched)
    );
  }
}
